import { ArrowUp, ArrowDown, Trash2, PackageOpen, PackageCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [
  ["company", "Firmă", "sm:col-span-2"],
  ["address", "Adresă completă (stradă, cod, oraș, țară)", "sm:col-span-2"],
  ["date", "Data", ""],
  ["time", "Interval orar", ""],
  ["reference", "Referință încărcare/descărcare", ""],
  ["contact", "Contact la locație", ""],
];

export function StopEditor({ stop, index, total, onChange, onMove, onRemove }) {
  const set = (k, v) => onChange({ ...stop, [k]: v });
  const isLoad = stop.type === "loading";
  const Icon = isLoad ? PackageOpen : PackageCheck;
  return (
    <div className={`rounded-xl border p-4 ${isLoad ? "border-violet-500/30 bg-violet-500/[0.04]" : "border-cyan-500/30 bg-cyan-500/[0.04]"}`} data-testid={`stop-editor-${index}`}>
      <div className="mb-3 flex items-center gap-2">
        <Icon className={`h-4 w-4 ${isLoad ? "text-violet-400" : "text-cyan-400"}`} />
        <select value={stop.type} onChange={(e) => set("type", e.target.value)} data-testid={`stop-type-${index}`}
          className="rounded-md border border-white/10 bg-[#0A0E17] px-2 py-1 font-display text-base font-semibold uppercase">
          <option value="loading">Încărcare</option>
          <option value="unloading">Descărcare</option>
        </select>
        <span className="font-mono text-xs text-slate-500">#{index + 1}</span>
        <div className="ml-auto flex gap-1">
          <IconBtn disabled={index === 0} onClick={() => onMove(-1)} testId={`stop-up-${index}`}><ArrowUp className="h-3.5 w-3.5" /></IconBtn>
          <IconBtn disabled={index === total - 1} onClick={() => onMove(1)} testId={`stop-down-${index}`}><ArrowDown className="h-3.5 w-3.5" /></IconBtn>
          <IconBtn onClick={onRemove} testId={`stop-remove-${index}`}><Trash2 className="h-3.5 w-3.5 text-red-400" /></IconBtn>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, label, span]) => (
          <label key={k} className={`space-y-1 ${span}`}>
            <span className="text-xs text-slate-400">{label}</span>
            <Input value={stop[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`stop-${k}-${index}`} />
          </label>
        ))}
        <label className="space-y-1 sm:col-span-2">
          <span className="text-xs text-slate-400">Instrucțiuni pentru această oprire</span>
          <Textarea rows={2} value={stop.notes || ""} onChange={(e) => set("notes", e.target.value)} data-testid={`stop-notes-${index}`} />
        </label>
      </div>
    </div>
  );
}

const IconBtn = ({ children, testId, ...props }) => (
  <button type="button" data-testid={testId} {...props} className="rounded-md border border-white/10 p-1.5 transition-colors hover:bg-white/5 disabled:opacity-30">
    {children}
  </button>
);
